import React from 'react';
import styled from 'styled-components';
//import { Route, Switch, Redirect } from 'react-router-dom';
import { Route, Switch } from 'react-router-dom';
import config from '../config';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { borrarDatosSesion, getItemDatosSesion, existeSesion } from '../funciones_globales/manejosesion';
import { visualizarAlerta } from '../actions/generales/act_gen01';
import moment from 'moment';
import Header from './componentes_generales/layout/header/header';
import Menu from './componentes_generales/layout/menu/menu';
import Alert from './componentes_generales/layout/alert/alert';
import Loading from './componentes_generales/layout/spinner/loading';
import Unauthorized from './componentes_generales/layout/menu/unauthorized';
import FormInven01 from './inventario/form_inven01';
import FormInven02 from './inventario/form_inven02';
import FormInven03 from './inventario/form_inven03';
import FormInven04 from './inventario/form_inven04';
import FormInven05 from './inventario/form_inven05';
import FormInven06 from './inventario/form_inven06';
import FormInven07 from './inventario/form_inven07';
import FormInven08 from './inventario/form_inven08';
import FormInven09 from './inventario/form_inven09';
import FormImpor01 from './importaciones/form_impor01';
import FormImpor02 from './importaciones/form_impor02';
import FormImpor03 from './importaciones/form_impor03';
import FormImpor04 from './importaciones/form_impor04';
import FormImpor05 from './importaciones/form_impor05';
import FormImpor06 from './importaciones/form_impor06';
import FormImpor07 from './importaciones/form_impor07';
import FormImpor08 from './importaciones/form_impor08';
import FormImpor09 from './importaciones/form_impor09';
import FormImpor10 from './importaciones/form_impor10';
import FormImpor11 from './importaciones/form_impor11';
import FormImpor12 from './importaciones/form_impor12';
import FormImpor13 from './importaciones/form_impor13';
import FormImpor14 from './importaciones/form_impor14';
import FormImpor15 from './importaciones/form_impor15';
import FormImpor16 from './importaciones/form_impor16';
import FormCli01 from './clientes/form_cli01';
import FormCli02 from './clientes/form_cli02';
import FormCli03 from './clientes/form_cli03';
import FormCli04 from './clientes/form_cli04';
import FormCli05 from './clientes/form_cli05';
import FormCli06 from './clientes/form_cli06';
import FormCli07 from './clientes/form_cli07';
import FormCli08 from './clientes/form_cli08';
import FormCli09 from './clientes/form_cli09';
import FormCli10 from './clientes/form_cli10';
import FormCli11 from './clientes/form_cli11';
import FormCli12 from './clientes/form_cli12';
import FormCli13 from './clientes/form_cli13';
import FormCli14 from './clientes/form_cli14';
import FormCli15 from './clientes/form_cli15';
import FormCli16 from './clientes/form_cli16';
import FormCli17 from './clientes/form_cli17';
import FormCli19 from './clientes/form_cli19';
import FormCli20 from './clientes/form_cli20';
import FormVen01 from './ventas/form_ven01';
import FormVen02 from './ventas/form_ven02';
import FormVen03 from './ventas/form_ven03';
import FormVen04 from './ventas/form_ven04';
import FormVen05 from './ventas/form_ven05';
import FormVen06 from './ventas/form_ven06';
import FormVen07 from './ventas/form_ven07';
import FormVen08 from './ventas/form_ven08';
import FormVen09 from './ventas/form_ven09';
import FormVen10 from './ventas/form_ven10';
import FormVen11 from './ventas/form_ven11';
import FormVen12 from './ventas/form_ven12';
import FormVen14 from './ventas/form_ven14';
import FormVen15 from './ventas/form_ven15';
import FormVen16 from './ventas/form_ven16';
import FormVen17 from './ventas/form_ven17';
import FormVen18 from './ventas/form_ven18';
import FormVen19 from './ventas/form_ven19';
import FormVen20 from './ventas/form_ven20';
import FormVen21 from './ventas/form_ven21';
import FormVen22 from './ventas/form_ven22';
import FormVen23 from './ventas/form_ven23';
import FormVen24 from './ventas/form_ven24';
import FormVen25 from './ventas/form_ven25';
import FormVen26 from './ventas/form_ven26/form_ven26';
import FormVen36 from './ventas/form_ven36';
import FormVen37 from './ventas/form_ven37';
import FormVen38 from './ventas/form_ven38';
import FormVen40 from './ventas/form_ven40';
import FormVen41 from './ventas/form_ven41';
import FormVen42 from './ventas/form_ven42';
import FormCaja01 from './caja/form_caja01';
import FormCaja02 from './caja/form_caja02';
import FormCaja03 from './caja/form_caja03';
import FormCaja04 from './caja/form_caja04';
import FormCaja05 from './caja/form_caja05';
import FormCaja06 from './caja/form_caja06';
import FormCaja07 from './caja/form_caja07';
import FormCaja08 from './caja/form_caja08';
import FormCaja09 from './caja/form_caja09';
import FormCaja10 from './caja/form_caja10';
import FormCaja11 from './caja/form_caja11';
import FormCaja12 from './caja/form_caja12';
import FormComp01 from './compras/form_comp01';
import FormComp02 from './compras/form_comp02';
import FormComp03 from './compras/form_comp03';
import FormComp04 from './compras/form_comp04';
import FormComp05 from './compras/form_comp05';
import FormComp06 from './compras/form_comp06';
import FormComp07 from './compras/form_comp07';
import FormComp08 from './compras/form_comp08';
import FormComp09 from './compras/form_comp09';
import FormComp10 from './compras/form_comp10';
import FormComp11 from './compras/form_comp11';
import FormComp12 from './compras/form_comp12';
import FormComp13 from './compras/form_comp13';
import FormBanco01 from './bancos/form_banco01';
import FormBanco02 from './bancos/form_banco02';
import FormBanco03 from './bancos/form_banco03';
import FormBanco04 from './bancos/form_banco04';
import FormBanco05 from './bancos/form_banco05';
import FormBanco06 from './bancos/form_banco06';
import FormBanco07 from './bancos/form_banco07';
import FormBanco08 from './bancos/form_banco08';
import FormBanco09 from './bancos/form_banco09';
import FormBanco10 from './bancos/form_banco10';
import FormBanco11 from './bancos/form_banco11';
import FormBanco12 from './bancos/form_banco12';
import FormBanco13 from './bancos/form_banco13';
import FormCon01 from './contabilidad/form_con01';
import FormCon02 from './contabilidad/form_con02';
import FormCon03 from './contabilidad/form_con03';
import FormCon04 from './contabilidad/form_con04';
import FormCon05 from './contabilidad/form_con05';
import FormCon06 from './contabilidad/form_con06';
import FormCon07 from './contabilidad/form_con07';
import FormCon08 from './contabilidad/form_con08';
import FormCon09 from './contabilidad/form_con09';
import FormCartera01  from './cartera/form_cartera01';
import FormCartera02  from './cartera/form_cartera02';
import FormCartera03  from './cartera/form_cartera03';
import FormCartera04 from './cartera/form_cartera04';
import FormCartera05 from './cartera/form_cartera05';
import FormAdmin01 from './administracion/form_admin01';
import FormAdmin02 from './administracion/form_admin02';
import FormAdmin03 from './administracion/form_admin03';
import FormAdmin04 from './administracion/form_admin04';
import FormAdmin05 from './administracion/form_admin05';
import FormVende01 from './vendedores/form_vende01';
import FormVende02 from './vendedores/form_vende02';
import FormVende03 from './vendedores/form_vende03';
import FormInven12 from './inventario/form_inven12';
import FormInven13 from './inventario/form_inven13';
import FormInven16 from './inventario/form_inven16';
import FormInven11 from './inventario/form_inven11';
import FormInven15 from './inventario/form_inven15';
//import Dashboard from './dashboard';

const ContenedorApp = styled.div`
    max-width: 100%;
    font-family: Verdana, Geneva, sans-serif;
    -moz-user-select: none;
`;

const ContenedorCuerpoApp = styled.div`        
    margin-top: 40px;           
`;

const getAllowedRows = () => {
    try {
        return (getItemDatosSesion('menu')? JSON.parse(getItemDatosSesion('menu')): []).filter(menu => menu.Ruta!=null).map(menu => menu.Ruta);
    } catch (error) {
        return []
    }
}

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            getAllowedRows().includes(rest.path) ? (
                <Component {...props} />
            ) : (
                //<Redirect to="/unauthorized" /> //rtoala20230914
                <Component {...props} />
            )
        }
    />
);

class App extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            events: [/* "mousemove", */ "mousedown", "keydown", "touchstart", "scroll"],
            detectarInactividadEnSegundos: config.detectarInactividadEnSegundos,
            idTimeoutInact: null,
            idTimeoutSesion: null,
            idTimeoutSesionPorFinal: null
        };
        this.attachEvents = this.attachEvents.bind(this);
        this.removeEvents = this.removeEvents.bind(this);
        this.setTimeoutInactividadUsuario = this.setTimeoutInactividadUsuario.bind(this);
        this.setTimeoutSesion = this.setTimeoutSesion.bind(this);
        this.handleEvent = this.handleEvent.bind(this);
    }

    componentDidMount(){
        this.attachEvents();
        this.setTimeoutInactividadUsuario();

        if (this.state.idTimeoutSesion!==null){
            clearTimeout(this.state.idTimeoutSesion);
        }

        if (this.state.idTimeoutSesionPorFinal!==null){
            clearTimeout(this.state.idTimeoutSesionPorFinal);
        }

        let tiempoSesionEnSeg = getItemDatosSesion('sesionExpiraEnSeg');
        let tiempoSesionEnMilisegundos = (tiempoSesionEnSeg*1000) - (moment().diff(moment(getItemDatosSesion('fechaInicSesion'))));
        this.setTimeoutSesion(tiempoSesionEnMilisegundos);
    }

    componentWillUnmount() {
        this.removeEvents();
        clearTimeout(this.state.idTimeoutInact);
        clearTimeout(this.state.idTimeoutSesion);
        clearTimeout(this.state.idTimeoutSesionPorFinal);

        this.props.visualizarAlerta({ isVisible: false, tipo: '', titulo: '', mensaje: '' });
    }

    attachEvents() {
        this.state.events.forEach(event => {
          window.addEventListener(event, this.handleEvent, true);
        });
    }

    removeEvents() {
        this.state.events.forEach(event => {
          window.removeEventListener(event, this.handleEvent, true);
        });
    }

    handleEvent = () => {
        clearTimeout(this.state.idTimeoutInact);

        if(!existeSesion()){
            this.props.history.push('/login');
        }

        this.setTimeoutInactividadUsuario();
    }

    setTimeoutInactividadUsuario() {
        let idTimeoutInact = setTimeout(() => {
            borrarDatosSesion();
            let alerta = {isVisible: true, mensaje: 'Su sesión ha sido finalizada automáticamente puesto que Ud. no ha tenido interacción con el sistema en los últimos minutos. Vuelva a iniciar sesión.'};
            this.props.visualizarAlerta(alerta);
        }, (this.state.detectarInactividadEnSegundos*1000));

        this.setState({ idTimeoutInact });
    }

    setTimeoutSesion(tiempoSesionEnMilisegundos){
        let tiempoSesionPorFinalizar = (tiempoSesionEnMilisegundos - 60000)<0?0:(tiempoSesionEnMilisegundos - 60000);
        let idTimeoutSesionPorFinal;
        if (tiempoSesionPorFinalizar>0){
            idTimeoutSesionPorFinal = setTimeout(() => {
                let alerta = {isVisible: true, tipo: 'warning', mensaje: 'Su sesión caducará en 1 minuto, asegúrese de guardar sus cambios.'};
                this.props.visualizarAlerta(alerta);
            }, tiempoSesionPorFinalizar);
        }

        let idTimeoutSesion = setTimeout(()=>{
            this.props.visualizarAlerta({ isVisible: false, tipo: '', titulo: '', mensaje: '' });
            borrarDatosSesion();
            this.props.history.push('/login');
        }, tiempoSesionEnMilisegundos);

        this.setState({ idTimeoutSesionPorFinal, idTimeoutSesion });
    }

    render(){

    return(
        <ContenedorApp>
            <Loading isLoading={this.props.isVisibleLoading}/>
            <Header/>
            <Menu/>
            <ContenedorCuerpoApp>
                <Switch>
                    {/* <Route exact path="/" component={Dashboard}/> */}

                    {/* Clientes routes */}
                    <PrivateRoute path="/clientes/mantenimientocliente" component={FormCli01}/>
                    <PrivateRoute path="/clientes/modificacionfechacheques" component={FormCli02}/>
                    <PrivateRoute path="/clientes/carteracheques" component={FormCli03}/>
                    <PrivateRoute path="/clientes/registronotacredito" component={FormCli04}/>
                    <PrivateRoute path="/clientes/registronotadebito" component={FormCli05}/>
                    <PrivateRoute path="/clientes/estadoctacliente" component={FormCli06}/>
                    <PrivateRoute path="/clientes/registrochequesprotestados" component={FormCli07}/>
                    <PrivateRoute path="/clientes/repfichaclienteporvendedor" component={FormCli08}/>
                    <PrivateRoute path="/clientes/registrocanjecheques" component={FormCli09}/>
                    <PrivateRoute path="/clientes/descuentocliente" component={FormCli10}/>
                    <PrivateRoute path="/clientes/planilladepositocheques" component={FormCli11}/>
                    <PrivateRoute path="/clientes/chequeporcuenta" component={FormCli12}/>
                    <PrivateRoute path="/clientes/registrogestiones" component={FormCli13}/>
                    <PrivateRoute path="/clientes/reporterecursoslicitoscliente" component={FormCli14}/>
                    <PrivateRoute path="/clientes/matriculacioncuentas" component={FormCli15}/>
                    <PrivateRoute path="/clientes/reportencfavor" component={FormCli16}/>
                    <PrivateRoute path="/clientes/reportechequeprotestadocanjeado" component={FormCli17}/>
                    <PrivateRoute path="/clientes/entregachequevendedor" component={FormCli19}/>
					<PrivateRoute path="/clientes/facturaseguro" component={FormCli20}/>

                    {/* Inventario routes */}
                    <PrivateRoute path="/inventario/mantenimientoarticulo" component={FormInven01}/>
                    <PrivateRoute path="/inventario/mantenimientotransferencia" component={FormInven02}/>
                    <PrivateRoute path="/inventario/mantenimientoprecios" component={FormInven03}/>
                    <PrivateRoute path="/inventario/ingresobodega" component={FormInven04}/>
                    <PrivateRoute path="/inventario/egresobodega" component={FormInven05}/>
                    <PrivateRoute path="/inventario/existenciabodegavalorizada" component={FormInven06}/>
                    <PrivateRoute path="/inventario/kardexporarticulo" component={FormInven07}/>
                    <PrivateRoute path="/inventario/movimientosbodega" component={FormInven08}/>
                    <PrivateRoute path="/inventario/catalogoarticulos" component={FormInven09}/>
                    <PrivateRoute path="/inventario/retrasodespacho/" component={FormInven11}/>
                    <PrivateRoute path="/inventario/tomainventario/" component={FormInven12}/>
                    <PrivateRoute path="/inventario/diferenciasinventario/" component={FormInven13}/> {/*Reporte Diferencias entre Inventarios */}
                    <PrivateRoute path="/inventario/transaccionesinventario/" component={FormInven15}/> {/*Diferencia Stock según Kardex vs Stock Acumulado*/}
                    <PrivateRoute path="/inventario/precioporexcel/" component={FormInven16}/> {/*Consolidado Importacion*/}

                    {/* Importaciones routes */}
                    <PrivateRoute path="/importaciones/mantenimientogastosimportacion" component={FormImpor01}/>
                    <PrivateRoute path="/importaciones/importacion" component={FormImpor02}/>
                    <PrivateRoute path="/importaciones/ajustepagoimportacion" component={FormImpor03}/>
                    <PrivateRoute path="/importaciones/actualizacionpartidasarancelarias" component={FormImpor04}/>
                    <PrivateRoute path="/importaciones/planimportacion" component={FormImpor05}/>
                    <PrivateRoute path="/importaciones/liberacioncompra" component={FormImpor06}/>
                    <PrivateRoute path="/importaciones/liberacioncompra" component={FormImpor06}/>
                    <PrivateRoute path="/importaciones/flujopagos" component={FormImpor07}/>
                    <PrivateRoute path="/importaciones/importaciontransito" component={FormImpor08}/>
                    <PrivateRoute path="/importaciones/repgastodeimportacion" component={FormImpor09}/>
                    <PrivateRoute path="/importaciones/repimportacionfobcosto" component={FormImpor10}/>
                    <PrivateRoute path="/importaciones/repimportacionsaldotransito" component={FormImpor11}/>
                    <PrivateRoute path="/importaciones/importacionesmanuales" component={FormImpor12}/>
                    <PrivateRoute path="/importaciones/consolidadoimportacion/" component={FormImpor13}/>
                    <PrivateRoute path="/importaciones/importacionexcel/" component={FormImpor14}/>
                    <PrivateRoute path="/importaciones/importacionactualizafecha" component={FormImpor15}/>
                    <PrivateRoute path="/importaciones/repimportacionventa" component={FormImpor16}/>

                    {/* Ventas routes */}
                    <PrivateRoute path="/ventas/revisionpedidosmoviles" component={FormVen01}/>
                    <PrivateRoute path="/ventas/registroproforma" component={FormVen02}/>
                    <PrivateRoute path="/ventas/registroembalaje" component={FormVen03}/>
                    <PrivateRoute path="/ventas/registrodevolucion" component={FormVen04}/>
                    <PrivateRoute path="/ventas/registrodevolucionelect" component={FormVen05}/>
                    <PrivateRoute path="/ventas/registroguiaremision" component={FormVen06}/>
                    <PrivateRoute path="/ventas/vendedoresporzona" component={FormVen07}/>
                    <PrivateRoute path="/ventas/aprobaciondevoluciones" component={FormVen08}/>
                    <PrivateRoute path="/ventas/consultafactura" component={FormVen09}/>
                    <PrivateRoute path="/ventas/articulosvendportipocompra" component={FormVen10}/>
                    <PrivateRoute path="/ventas/proformaspendfacturar" component={FormVen11}/>
                    <PrivateRoute path="/ventas/listapreciosarticulos" component={FormVen12}/>
                    <PrivateRoute path="/ventas/devoluciones" component={FormVen19}/>
                    <PrivateRoute path="/ventas/devolucioneselectporestado" component={FormVen14}/>
                    <PrivateRoute path="/ventas/ventasporfactnotaventa" component={FormVen15}/>
                    <PrivateRoute path="/ventas/etiquetadespacho" component={FormVen16}/>
                    <PrivateRoute path="/ventas/analisisrentabilidad" component={FormVen17}/>
                    <PrivateRoute path="/ventas/proformasanuladas" component={FormVen18}/>
                    <PrivateRoute path="/ventas/detalleventascostos" component={FormVen20}/>
                    <PrivateRoute path="/ventas/aprobaciondevolucionesflujogerencial" component={FormVen21}/>
                    <PrivateRoute path="/ventas/facturasanuladas" component={FormVen22}/>
                    <PrivateRoute path="/ventas/consolidadoventas" component={FormVen23}/>
                    <PrivateRoute path="/ventas/articulosnodespachados" component={FormVen24}/>
                    <PrivateRoute path="/ventas/ordentransferenciaretirar" component={FormVen25}/>
                    <PrivateRoute path="/ventas/registroencartonado" component={FormVen26}/>
                    <PrivateRoute path="/ventas/comisioncomercial" component={FormVen36}/>
                    <PrivateRoute path="/ventas/ventaslineavendedor" component={FormVen37}/>
                    <PrivateRoute path="/ventas/devoluciontipo" component={FormVen38}/>
                    <PrivateRoute path="/ventas/actpedidoterpago" component={FormVen40}/>
                    <PrivateRoute path="/ventas/rguiaremision" component={FormVen41}/>
                    <PrivateRoute path="/ventas/pedidomargen" component={FormVen42}/>

                    {/* Caja routes */}
                    <PrivateRoute path="/caja/cobranza" component={FormCaja01}/>
                    <PrivateRoute path="/caja/movimientocaja" component={FormCaja02}/>
                    <PrivateRoute path="/caja/modificacionrecibos" component={FormCaja03}/>
                    <PrivateRoute path="/caja/cajachica" component={FormCaja04}/>
                    <PrivateRoute path="/caja/reportemovimientoscaja" component={FormCaja05}/>
                    <PrivateRoute path="/caja/cortecobranza" component={FormCaja06}/>
                    <PrivateRoute path="/caja/reporteconsolidadocobranza" component={FormCaja07}/>
                    <PrivateRoute path="/caja/ingresopresupuestocobranza" component={FormCaja08}/>
                    <PrivateRoute path="/caja/retencionclientesri" component={FormCaja09}/>
                    <PrivateRoute path="/caja/reporteretencionclientesri" component={FormCaja10}/>
                    <PrivateRoute path="/caja/reporteRetcliente" component={FormCaja11}/>
                    <PrivateRoute path="/caja/reporteFacPendiRete" component={FormCaja12}/>

                    {/* Compras routes */}
                    <PrivateRoute path="/compras/proveedores" component={FormComp01}/>
                    <PrivateRoute path="/compras/mantenimientocompra" component={FormComp02}/>
                    <PrivateRoute path="/compras/notascreditoproveedor" component={FormComp03}/>
                    <PrivateRoute path="/compras/planificacionpagos" component={FormComp04}/>
                    <PrivateRoute path="/compras/diariocompras" component={FormComp05}/>
                    <PrivateRoute path="/compras/aprobacionpagos" component={FormComp07}/>
                    <PrivateRoute path="/compras/carteraporpagarproveedoreslocales" component={FormComp08}/>
                    <PrivateRoute path="/compras/anticipoproveedor" component={FormComp06}/>
                    <PrivateRoute path="/compras/comprasproveedoresextranjeros" component={FormComp09}/>
                    <PrivateRoute path="/compras/repanticipoproveedor" component={FormComp10}/>
                    <PrivateRoute path="/compras/compraslocales" component={FormComp11}/>
                    <PrivateRoute path="/compras/fichaproveedor" component={FormComp12}/>
                    <PrivateRoute path="/compras/historicoproveedor" component={FormComp13}/>

                    {/* Bancos routes */}
                    <PrivateRoute path="/bancos/emisioncheques" component={FormBanco01}/>
                    <PrivateRoute path="/bancos/depositocheques" component={FormBanco02}/>
                    <PrivateRoute path="/bancos/notacreditodebito" component={FormBanco03}/>
                    <PrivateRoute path="/bancos/impresionpapeletadeposito" component={FormBanco04} />
                    <PrivateRoute path="/bancos/distribucioncheques" component={FormBanco05}/>
                    <PrivateRoute path="/bancos/depositosefecporcobranza" component={FormBanco06}/>
                    <PrivateRoute path="/bancos/movimientoportipo" component={FormBanco07}/>
                    <PrivateRoute path="/bancos/mvtosefectivopenddeposito" component={FormBanco08}/>
                    <PrivateRoute path="/bancos/resumendepositoefectivo" component={FormBanco09}/>
                    <PrivateRoute path="/bancos/movimientosanulados" component={FormBanco10}/>
                    <PrivateRoute path="/bancos/saldoscuentasbancarias" component={FormBanco11}/>
                    <PrivateRoute path="/bancos/depositos" component={FormBanco12}/>
                    <PrivateRoute path="/bancos/mantenimientoctasbancarias" component={FormBanco13}/>

                    {/* Contabilidad routes */}
                    <PrivateRoute path="/contabilidad/registrodecomprobante" component={FormCon01}/>
                    <PrivateRoute path="/contabilidad/mayoranalitico" component={FormCon02}/>
                    <PrivateRoute path="/contabilidad/mayorizacion" component={FormCon03}/>
                    <PrivateRoute path="/contabilidad/ajustegastosimportacion" component={FormCon04}/>
                    <PrivateRoute path="/contabilidad/estadosituacionfinanciera" component={FormCon05}/>
                    <PrivateRoute path="/contabilidad/ats" component={FormCon06}/>
                    <PrivateRoute path="/contabilidad/generadordinardap" component={FormCon07}/>
                    <PrivateRoute path="/contabilidad/mantenimientoplancuentas" component={FormCon08}/>
                    <PrivateRoute path="/contabilidad/asientosporcomprobante" component={FormCon09}/>

                    {/* Cartera routes */}
                    <PrivateRoute path="/cartera/cuentasporcobrarclientes" component={FormCartera01}/>
                    <PrivateRoute path="/cartera/cuentasporcobrarriesgototal" component={FormCartera02}/>
                    <PrivateRoute path="/cartera/carteraporedades" component={FormCartera03}/>
                    <PrivateRoute path="/cartera/cobranzaefectiva" component={FormCartera04}/>
                    <PrivateRoute path="/cartera/historicocartera" component={FormCartera05}/>

                    {/* Admin routes */}
                    <PrivateRoute path="/admin/modificacionfechatransaccion" component={FormAdmin01}/>
                    <PrivateRoute path="/admin/restriccioningresocobranza" component={FormAdmin02}/>
                    <PrivateRoute path="/admin/formulariocierre" component={FormAdmin03}/>
                    <PrivateRoute path="/admin/accesocuentadepartamento" component={FormAdmin04}/>
                    <PrivateRoute path="/admin/mantenimientotabla" component={FormAdmin05}/>

                    {/* Vendedores routes */}
                    <PrivateRoute path="/vendedor/reporteventacobranza" component={FormVende01}/>
                    <PrivateRoute path="/vendedor/ingresopedidomovil" component={FormVende02}/>
                    <PrivateRoute path="/vendedor/consultapedidomovil" component={FormVende03}/>

                    <Route path="/unauthorized" component={Unauthorized}/>
                    
                </Switch>
            </ContenedorCuerpoApp>
            <Alert/>
        </ContenedorApp>
    );
  }
}    

const mapStateToProps = ((state) => {
    return {isVisibleLoading: state.ui.isVisibleLoading, isVisibleMenu: state.ui.isVisibleMenu}
});

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ visualizarAlerta }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(App);